import { EMDASH } from 'constants';

// [ Married, Separated, CoParent, DivorcedSharedCustody, DivorcedSoleCustody, POA ]
export const ADULT_MARITAL_STATUS_OPTIONS = {
  MARRIED: 'Married',
  SINGLE: 'Single',
  SEPARATED: 'Separated',
  CO_PARENT: 'CoParent',
  DIVORCED_SHARED_CUSTODY: 'DivorcedSharedCustody',
  POA: 'POA',
};

// Helper function to get the appropriate spouse title based on application data
export function getSpouseTitle(application) {
  const maritalStatus = application?.applicant?.maritalStatus;
  const partnerStatus = application?.applicant?.partnerStatus;

  if (maritalStatus === ADULT_MARITAL_STATUS_OPTIONS.MARRIED) {
    return 'spouse';
  }

  if (maritalStatus === ADULT_MARITAL_STATUS_OPTIONS.SEPARATED) {
    return 'spouse (separated)';
  }

  // For single, use partner status to determine the relationship
  if (maritalStatus === ADULT_MARITAL_STATUS_OPTIONS.SINGLE && partnerStatus) {
    switch (partnerStatus) {
      case ADULT_MARITAL_STATUS_OPTIONS.CO_PARENT:
        return 'co-parent';
      case ADULT_MARITAL_STATUS_OPTIONS.DIVORCED_SHARED_CUSTODY:
        return 'ex-spouse';
      case ADULT_MARITAL_STATUS_OPTIONS.POA:
        return 'Power of Attorney';
      default:
        return 'spouse';
    }
  }

  return 'spouse'; // Default fallback
}

export function getChildRelationshipToAddlAdult(childRelationshipToAdditionalAdult) {
  // Map the relationship value to display text
  switch (childRelationshipToAdditionalAdult) {
    case 'Child':
      return 'child';
    case 'Stepchild':
    case 'Step Child':
      return 'step child';
    case 'FosterChild':
    case 'Foster Child':
      return 'foster child';
    case 'LegalGuardian':
    case 'Legal Guardian/Ward':
      return 'ward';
    default:
      return childRelationshipToAdditionalAdult?.toLowerCase() || EMDASH;
  }
}

export const FAMILY_SPOUSE_UNEMPLOYMENT_REASON = {
  JobSearch: 'JobSearch',
  MedicalReason: 'MedicalReason',
  Other: 'Other',
};
